<template lang="pug">
.video-library-swiper(ref="swiper")
    .swiper-wrapper
        template(v-for="result in results")
            slot(
                name="item",
                :result="result",
                :openInNewWindow="options.openInNewWindow",
                :formatDate="formatDate"
            )
                Item(:result="result", :openInNewWindow="options.openInNewWindow", :formatDate="formatDate")
    button.video-library-swiper__prev.swiper-button-prev(aria-label="Previous Slide")
        i.fas.fa-arrow-left 
    button.video-library-swiper__next.swiper-button-next(aria-label="Next Slide")
        i.fas.fa-arrow-right
</template>

<script>
import Item from "./Item.vue";
import shave from 'shave';
import Swiper, { Navigation, A11y } from 'swiper';
import { format } from "date-fns";

export default {
    name: "VideoLibraryResultsCategory",
    components: { Item },
    props: ['results', 'searchSubmitted'],
    data() {
    return {
    };
    },
    computed: {
    
    },
    methods: {
        formatDate(date, formatPattern) {
            return format(new Date(date), formatPattern);
        },
        initSwiper() {
            Swiper.use([Navigation, A11y]);
            // [slidesPerView, spaceBetween]
            // const truncate = registration.querySelectorAll('.text-truncate')
            const truncate = this.$refs.swiper.querySelectorAll('.text-truncate')
            const maxheight = 50
            let sizesLg = [3.5,30]
            if(this.$refs.swiper.classList.contains('video-library-swiper--large')) {
            // variant for the fundamentals page
            sizesLg = [3,15]
            }
            // Swiper.use([Autoplay]);
            setTimeout(() => {
            const swiper = new Swiper(this.$refs.swiper, {
                direction: 'horizontal',
                // slidesPerView: 3,
                // spaceBetween: 30,
                breakpoints: {
                    1: {
                        slidesPerView: 1.5,
                        spaceBetween: 30,
                    },
                    576: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                    },
                    900: {
                        slidesPerView: sizesLg[0],
                        spaceBetween: sizesLg[1],
                    }
                },
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
            truncate.forEach(e => {
                shave(e, maxheight)
            });
            
            }, 750);
        }
    },
    mounted() {
        this.initSwiper()
        // console.log(this.$refs)
    }
};
</script>

<style lang="scss" scoped>
span.root {
    display: contents;
}
.search__results {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    &-empty {
    font-style: italic;
    margin: 2rem;
    text-align: center;
    }
}
</style>